import { render, staticRenderFns } from "./DistributionGeneralSetupForm.vue?vue&type=template&id=7ea075ff&scoped=true&"
import script from "./DistributionGeneralSetupForm.vue?vue&type=script&lang=js&"
export * from "./DistributionGeneralSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea075ff",
  null
  
)

export default component.exports